export function postMessageScrollTop() {
  if (window.parent) window.parent.postMessage('bpScrollTop', '*')
}
